import React, { useEffect } from 'react';
import { useHeadTags, escapeAttr } from 'src/core/engine/head';
import { contact } from 'src/config';

import classes from './Header.scss';

const desktop = require('../../../static/img/logo-header-desktop.svg');
const mobile = require('../../../static/img/logo-header-mobile.svg');

export function Logo() {
    const { setHead } = useHeadTags();
    const onClick = () => {
        if (window.location.href.includes('/checkout/payment') || window.location.href.includes('/checkout/success')) {
            location.replace('/');
        }
    };

    useEffect(() => {
        setHead({ link: `<link rel="preload" href="${escapeAttr(desktop)}" as="image" />` });
    }, [setHead]);

    return (
        <picture className={classes.headerLogo} onClick={onClick}>
            <source media="(min-width: 900px)" srcSet={desktop} />
            <source media="(max-width: 900px)" srcSet={mobile} />
            <img alt={contact.name} src={desktop} />
        </picture>
    );
}
